module.exports = __webpack_public_path__ + "static/media/help_Votar.94270bac.png";